<template>
  <div>
    <Form
      @submit.native.prevent
      ref="formItem"
      :model="formItem"
      :rules="ruleValidate"
      label-position="top"
    >

      <FormItem
        label="类型"
        prop="payTo"
      >
        <Select
          v-model="formItem.paymentItem"
          clearable
          placeholder="请选择付款对象后选择"
        >
          <Option
            v-for="option in paymentItemList"
            :value="option.item"
            :key="option.item"
            style="width: 330px"
          >{{ option.zh }}</Option>
        </Select>
      </FormItem>

      
      <!-- <FormItem
        :label="payToLabel"
        prop="payTo"
        v-if="isPayToRequire"
      >
        <Select
          v-model="formItem.payTo"
          filterable
          :disabled="openedPayment || isPayToDisabled ? true : false"
          remote
          clearable
          style="width: 330px"
          :remote-method="remoteMethod"
          :loading="customerLoading"
          placeholder="请选择付款对象后选择"
        >
          <Option
            v-for="option in payToList"
            :value="option._id"
            :key="option._id"
            style="width: 330px"
          >{{ option.name }}</Option>
        </Select>
      </FormItem> -->

    </Form>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { arrayIntersection } from "@/utils";
import { paymentItemList } from "./paymentConstant";
import dayjs from "dayjs";
import lodash from "lodash";

export default {
  name: "PaymentApplicationPanel",
  data() {
    return {
      drawerOpened: false,
      openedPayment: null,
      customerLoading: false,
      formItem: {

      },
      ruleValidate: {

      }
    };
  },
  computed: {
    ...mapState({
      companyList: (state) => state.company.companyList,
      simpleBankAccount: (state) => state.bankAccount.simpleBankAccount,
      customersSimple: (state) => state.customer.customersSimple,
      user: (state) => state.auth.currentUser,
      simpleUserList: (state) => state.user.simpleUserList,
      supplierList: (state) => state.supplier.supplierList,
      entityList: (state) => state.entity.entityList,
      billList: (state) => state.bill.billList,
    }),
    paymentItemList: () => paymentItemList
  },
  methods: {

  },
  created() {
  },
  mounted() {


  },
  destroyed() {
  },
};
</script>

<style scoped lang="stylus">

</style>
